/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Type_Air_Handler_UnitInputs */



/**
* | output |
* | --- |
* | "AHU" |
*
* @param {Entity_Type_Air_Handler_UnitInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const entity_type_air_handler_unit = /** @type {((inputs?: Entity_Type_Air_Handler_UnitInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Type_Air_Handler_UnitInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("AHU")
	return /** @type {LocalizedString} */ ("CTA")
});